import script from "./BasePagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePagination.vue?vue&type=script&setup=true&lang=js"

import "./BasePagination.vue?vue&type=style&index=0&id=6ca84fef&lang=scss"

const __exports__ = script;

export default __exports__